import React, { Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from './../../../../lib/bem';
import {
  addDocumentoFVG,
  postCaptcha,
  postConsultarCreateSimulacion,
} from './../../../../redux/reducers/simuladorFVGSlice';
import InputDocumentComponent from './../../../../components/inputDocument/inputDocument_component';
import LayoutSimuladorComponent from './../../components/layoutSimulador/layoutSimulador_Component';
import ButtonComponent from './../../../../components/button/button_component';
import ModalDatosPersonalesComponent from './../../components/modalDatosPersonales/modalDatosPersonales_Component';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import './datos_personales.scss';

const DatosPersonales = () => {
  const classes = cn('datosPersonales');
  const dispatch = useDispatch();

  const simuladorFVG = useSelector((state) => state.rootReducers.simuladorFVG);

  const [mostrarModal, setMostrarModal] = useState(false);
  const [mostrarActua, setMostrarActua] = useState(false);

  const [tipoDocumento, guardarTipoDocumento] = useState(
    simuladorFVG.tipoDocumento
  );
  const [nroDocumento, guardarNroDocumento] = useState(
    simuladorFVG.nroDocumento
  );
  const [msgDocumento, guardarMsgDocumento] = useState('');
  const [mensajeError, setMensajeError] = useState('');

  const { executeRecaptcha } = useGoogleReCaptcha();

  const onClickGuardarDocumento = async () => {
    if (nroDocumento.trim() === '') {
      guardarMsgDocumento('El campo es obligatorio');
      return false;
    }

    if (tipoDocumento === '1' && nroDocumento.length !== 8) {
      guardarMsgDocumento('El campo debe ser un número válido');
      return false;
    }

    if (tipoDocumento === '3' && nroDocumento.length < 8) {
      guardarMsgDocumento('El campo debe ser un número válido');
      return false;
    }

    dispatch(
      addDocumentoFVG({
        tipoDocumento: tipoDocumento,
        nroDocumento: nroDocumento,
      })
    );

    const token = await executeRecaptcha('ecowebapp');

    if (process.env.REACT_APP_ACTIVE_VALIDATION_RECAPTCHA === 'true') {
      dispatch(postCaptcha(token)).then((resp) => {
        if (resp.payload.datos.esValido) {
          dispatch(
            postConsultarCreateSimulacion({
              tipoDocumento: tipoDocumento,
              numeroDocumento: nroDocumento,
            })
          ).then((resp) => {
            if (!resp.payload) {
              setMostrarModal(true);
              setMostrarActua(false);
            } else {
              if (resp.payload.datos.mensaje !== null) {
                setMensajeError(resp.payload.datos.mensaje);
              } else {
                setMostrarModal(true);
                setMostrarActua(true);
                setMensajeError('');
              }
            }
          });
        } else {
          setMensajeError('Ocurrio un error al validar el captcha');
        }
      });
    } else {
      dispatch(
        postConsultarCreateSimulacion({
          tipoDocumento: tipoDocumento,
          numeroDocumento: nroDocumento,
        })
      ).then((resp) => {
        if (!resp.payload) {
          setMostrarModal(true);
          setMostrarActua(false);
        } else {
          if (resp.payload.datos.mensaje !== null) {
            setMensajeError(resp.payload.datos.mensaje);
          } else {
            setMostrarModal(true);
            setMostrarActua(true);
            setMensajeError('');
          }
        }
      });
    }
  };

  return (
    <Fragment>
      {mostrarModal ? (
        <ModalDatosPersonalesComponent
          onClose={setMostrarModal}
          mostrarActua={mostrarActua}
        />
      ) : null}
      <LayoutSimuladorComponent
        laoding={simuladorFVG.status === 'loading'}
        title={'Datos Personales'}
        desc={'Paso 1 de 2'}
        info={'1/2'}
        indice={1}
        action={null}
        body={
          <div className={classes()}>
            <p className={classes('datosPersonalesTitle')}>
              <b>Bienvenido a tu simulador del Seguro Fondo Vida Garantizado</b>
            </p>
            <p className={classes('datosPersonalesSubTitle')}>
              Queremos conocer un poco de ti, cuéntanos:
            </p>
            <br />
            <InputDocumentComponent
              valueTipoDoc={tipoDocumento}
              valueNroDoc={nroDocumento}
              valueMsgDoc={msgDocumento}
              onChangeTipoDoc={guardarTipoDocumento}
              onChangeNroDoc={guardarNroDocumento}
              onChangeMsgDoc={guardarMsgDocumento}
            />
            <p className={classes('mensajeError')}>{mensajeError}</p>
            <div className={classes('datosPersonalesButton')}>
              <ButtonComponent
                type="button"
                label={'btnContinuar'}
                tipo={'button-red'}
                disabled={nroDocumento === ''}
                action={onClickGuardarDocumento}
                nombre={'Continuar'}
              />
            </div>
          </div>
        }
      />
    </Fragment>
  );
};

export default DatosPersonales;
